import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { SignupPageRoutingModule } from './signup-page-routing.module';
import { SignupPageComponent } from './signup-page.component';
import { SignupModule } from '../signup/signup.module';

@NgModule({
  imports: [
    CommonModule,
    SignupModule,
    SignupPageRoutingModule,
    TrackingModule,
    UiModule,
  ],
  exports: [SignupPageComponent],
  declarations: [SignupPageComponent],
})
export class SignupPageModule {}
